/**
 * Reality Check modal lifecycle event names.
 *
 * The same three strings drive the REALITY_CHECK popup-queue entry (autoplay
 * stop/resume) over two transports:
 *   - Web: CoreEvents as { name: 'RealityCheck', data: <one of these> } from RG UM.
 *   - Android: native wrapper as { type: 'REALITY_CHECK_MODAL_EVENT', event: <one> }.
 */
export const REALITY_CHECK_MODAL_EVENTS = {
  SHOWN: 'reality-check-modal-will-be-displayed',
  MODAL_DISMISSED: 'reality-check-modal-dismissed',
  SETTINGS_DISMISSED: 'reality-check-settings-dismissed',
} as const;

/** The RC modal is on screen → queue REALITY_CHECK so autoplay stops. */
export const isRealityCheckShownEvent = (event?: string): boolean =>
  event === REALITY_CHECK_MODAL_EVENTS.SHOWN;

/** RC modal or settings dismissed → de-queue REALITY_CHECK so autoplay resumes. */
export const isRealityCheckDismissedEvent = (event?: string): boolean =>
  event === REALITY_CHECK_MODAL_EVENTS.MODAL_DISMISSED ||
  event === REALITY_CHECK_MODAL_EVENTS.SETTINGS_DISMISSED;
